/**
 * @file index.tsx
 *
 * @fileoverview Renders blog article job teasers.
 */

import BookmarkedJobsProvider from '~/jobiqo/components/BookmarkedJobs/context';
import JobTeaserCard from '~/jobiqo/components/Job/Teaser';
import { Job, Url } from '~/jobiqo/types/types';
import Link from '~/jobiqo/components/Link';
import { FormattedMessage } from 'react-intl';
import { Grid } from '~/vcl/atoms/06-layout/04-grid';
import { Cell } from '~/vcl/atoms/06-layout/04-grid/01-cell';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';

export interface BlogJobTeasersRowProps {
  /**
   * The jobs to display.
   */
  jobs: Job[];
  /**
   * The URL to the similar jobs.
   */
  url?: Url;
}

export default function BlogJobTeasersRow({
  jobs,
  url,
}: BlogJobTeasersRowProps) {
  return (
    <>
      <Grid columns={[1, 2]} margin={0}>
        <BookmarkedJobsProvider
          initialState={jobs.filter((job) => job.bookmarked)}
        >
          {jobs.map((job) => (
            <Cell display="grid" key={job.id}>
              <JobTeaserCard job={job} />
            </Cell>
          ))}
        </BookmarkedJobsProvider>
      </Grid>
      {url?.path && (
        <>
          <Spacing size="medium" />
          <Link href={url.path}>
            <FormattedMessage id="similar_jobs" defaultMessage="Similar jobs" />
          </Link>
        </>
      )}
    </>
  );
}
export { BlogJobTeasersRow };
